module.exports = __webpack_public_path__ + "img/Vietnam.db112bb4.gif";